import { UserProfileDisplayBaseDto } from './user-profile-display-base-dto';
import { Utils } from 'cc-common';

export class UserNameDisplayResultDto extends UserProfileDisplayBaseDto {
    id: string;
    displayName: string;
    infoUrl: string;

    getUserId(): string {
        return this.id;
    }

    getDisplayName(): string {
        return Utils.notNullOrEmpty(this.displayName) ? this.displayName : this.id;
    }

    get createdByDisplayText(): string {
        return Utils.notNullOrEmpty(this.displayName) ? this.displayName : null;
    }
}
